import type { TFunction } from 'i18next'

import { getActiveLocale, parseNaive } from '@/lib/utils'
import type { Payment } from '@/types/api'

/**
 * Otázka pred zmazaním prijatej platby - z detailov platby aj z okna
 * objednávky (Platby). Zmazanie sa nedá vrátiť a objednávka sa prepočíta:
 * lekcie, ktoré platba uhradila, budú znova neuhradené.
 */
export function confirmRemovePayment(t: TFunction, payment: Payment, symbol: string) {
  const date = parseNaive(payment.created)
  const amount = Number.parseFloat(payment.amount || '0')
  return window.confirm(
    t('payments.removeConfirm', {
      amount: `${new Intl.NumberFormat(getActiveLocale(), { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount)} ${symbol}`,
      method: t(`reservation.payment.${payment.payment_type}`),
      date: date ? date.toLocaleDateString(getActiveLocale()) : '',
    }),
  )
}
